<div class="filter">
  <div class="filter__search">
    <input
      type="text"
      id="search"
      name="searchClients"
      [(ngModel)]="data"
      class="input-app input-search"
      [placeholder]="placeholder"
    />
    <mat-icon class="icon-filter" [matMenuTriggerFor]="menu">tune</mat-icon>
    <mat-menu #menu="matMenu" class="menu-table">
      <button
        mat-menu-item
        (click)="activeFilter(item)"
        *ngFor="let item of options"
      >
        <span> {{ item.label }} </span>
      </button>
    </mat-menu>
  </div>
  <div class="filter__chips" [ngStyle]="calcWidth()">
    <!-- <mat-chip-list #chipList aria-label="Fruit selection">
      <mat-chip
        [selectable]="selectable"
        [removable]="removable"
        *ngFor="let item of chips"
        (removed)="removeItem(item)"
      >
        <span class="text-chips"> {{ item.label | titlecase }}: </span>
        <span class="text-chips-selected"> &#160;{{ item.selected }} </span>
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list> -->
  </div>
</div>
